import {Checkbox, Flex, Typography} from "antd";
import React, {useEffect} from "react";
import {resultStore} from "../../../store/admissions/admissionStore";
import {stepsStore} from "../../../store/admissions/stepperStore";
import {confirmpersdataText, confirmText, informText} from "../model/confirmationTexts";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default function Step14() {
    const {stepsData, setStepsData} = stepsStore();
    const {result, setResult} = resultStore();
    const {xl} = useBreakpoint()

    useEffect(() => {
        if (result.consent.confirm && result.consent.inForm && result.consent.confirmpersdata) {
            setStepsData({...stepsData, nextStep: true})
        }
    }, [result.consent]);

    return (
        <Flex vertical gap={24} style={{width: '100%'}} justify="center" align="center">
            <Typography.Text style={{fontSize: "20px"}} strong>Ознакомление и согласие</Typography.Text>
            <Flex style={{width: xl ? '70%' : '100%'}} vertical={true}>
                <Checkbox onChange={(event) => {
                    setResult({
                        ...result,
                        consent: {...result.consent, inForm: event.target.checked},
                    })
                    if (event.target.checked && result.consent.confirm && result.consent.inForm && result.consent.confirmpersdata) {
                        setStepsData({...stepsData, nextStep: true})
                    } else {
                        setStepsData({...stepsData, nextStep: false})
                    }
                }}>
                    <Typography.Text strong={true}>Ознакомлен(а):</Typography.Text>
                </Checkbox>
                <Flex
                    style={{paddingLeft: xl ? "50px" : "20px"}}
                    vertical={true}
                    justify={"flex-start"}
                    align={"flex-start"}
                    gap={8}
                >
                    {informText.get(result.kindsLevelFormation)?.map((text, index) => (
                        <Typography.Text key={index}>{`- ${text};`}</Typography.Text>
                    ))}
                </Flex>
            </Flex>
            <Flex style={{width: xl ? '70%' : '100%'}} vertical={true}>
                <Checkbox onChange={(event) => {
                    setResult({
                        ...result,
                        consent: {...result.consent, confirm: event.target.checked},
                    })
                    if (event.target.checked && result.consent.confirm && result.consent.inForm && result.consent.confirmpersdata) {
                        setStepsData({...stepsData, nextStep: true})
                    } else {
                        setStepsData({...stepsData, nextStep: false})
                    }
                }}>
                    <Typography.Text strong={true}>Подтверждаю:</Typography.Text>
                </Checkbox>
                <Flex
                    style={{paddingLeft: xl ? "50px" : "20px"}}
                    vertical={true}
                    justify={"flex-start"}
                    align={"flex-start"}
                    gap={8}
                >
                    {confirmText.get(result.kindsLevelFormation)?.map((text, index) => (
                        <Typography.Text key={index}>{`- ${text};`}</Typography.Text>
                    ))}
                </Flex>
            </Flex>
            <Flex
                style={{width: xl ? '70%' : '100%'}}
                align={"flex-start"}
                justify={"flex-start"}
            >
                <Checkbox onChange={(event) => {
                    setResult({
                        ...result,
                        consent: {...result.consent, confirmpersdata: event.target.checked},
                    })
                    if (event.target.checked && result.consent.confirm && result.consent.inForm && result.consent.confirmpersdata) {
                        setStepsData({...stepsData, nextStep: true})
                    } else {
                        setStepsData({...stepsData, nextStep: false})
                    }
                }}>
                    <Typography.Text
                        strong={true}>{confirmpersdataText.get(result.kindsLevelFormation)}</Typography.Text>
                </Checkbox>
            </Flex>
        </Flex>
    )
}